import styled from 'styled-components';
import { CALYPSO } from 'HubStyleTokens/colors';
import CheckmarkIcon from '../../../Icons/CheckmarkIcon';
const CompletedIcon = styled(CheckmarkIcon).withConfig({
  displayName: "CompletedIcon",
  componentId: "h0ytcs-0"
})(["margin-right:5px;position:relative;bottom:-3px;color:", ";"], CALYPSO);
export default CompletedIcon;